<div>
  <div
    class="rounded-t-lg bg-white overflow-y-scroll max-h-[80vh] relative"
    [style.padding-bottom]="footerHeight + 'px'"
  >
    @if (imageUrl) {
      <ctr-image-skeleton height="186px" [skeletonAppearance]="skeletonType" [imageUrl]="imageUrl"></ctr-image-skeleton>
    }
    <div class="sticky top-0 z-10 flex px-4 py-2 bg-white">
      <div class="flex gap-x-1 flex-1">
        <h2 ctrHotelColor>{{ title }}</h2>
        <ng-content select="[header]"></ng-content>
      </div>
      <button (click)="closeModal.emit()" type="button">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <ng-content select="[body]"></ng-content>
  </div>
  <div class="bg-gray-100 absolute bottom-0 w-full" #footerContent>
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
